import React, { useState, useEffect, FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon, UserAvatar } from "../../components/Component"; // Assuming these are properly typed elsewhere
import {
  DropdownItem,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

interface PurchaseRequestAsideProps {
  updateSm: (value: boolean) => void; // Function to update state
  sm: boolean; // Boolean state
}

const HandOverAside: FC<PurchaseRequestAsideProps> = ({ updateSm, sm }) => {
  const location = useLocation();
  const { data: allowedRoutes }: any = useSelector(
    (state: RootState) => state.allowedRoutes
  );
  useEffect(() => {
    sm
      ? document.body.classList.add("toggle-shown")
      : document.body.classList.remove("toggle-shown");
  }, [sm]);

  const isActive = (path: string): string => {
    return location.pathname === path ? "active" : "";
  };

  const LinkTo = ({ path }: { path: string }) => {
    if (!allowedRoutes.includes(path)) {
      return null;
    }
    switch (path) {
      case "material-handover-pending":
        return (
          <Link
            to={"/material-handover-pending"}
            className={isActive(`${process.env.PUBLIC_URL}/material-handover-pending`)}
          >
            <Icon name="plus-fill-c" />
            <span>Pending</span>
          </Link>
        );
      case "material-handover-list":
        return (
          <Link
            to={"/material-handover-list"}
            className={isActive(`${process.env.PUBLIC_URL}/material-handover-list`)}
          >
            <Icon name="eye-fill" />
            <span>List</span>
          </Link>
        );

      default:
        return null;
    }
  };

  return (
    <div className="card-inner-group">
      <div className="card-inner">
        <div className="user-account-info py-0">
          <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
            Hand Over
          </h6>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          {[
            "view-dispatch-list",
            "material-handover-pending",
            "material-handover-list",
          ].map((item) => (
            <li key={item} onClick={() => updateSm(false)}>
              <LinkTo path={item} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HandOverAside;
